<div class="container mt-4">
  <h2 class="mb-3">Add Your Listing</h2>
  <form (submit)="onSubmit($event)" class="p-3 shadow-sm bg-white rounded">
    <div class="row">
      <!-- LEFT — IMAGE + DRAG & DROP -->
      <div class="col-md-5">
        <div class="border p-2 text-center bg-light rounded drag-drop-area" (drop)="onFileDrop($event)"
          (dragover)="onDragOver($event)" (click)="fileInput.click()" style="cursor: pointer;">

          <!-- Hidden file input -->
          <input #fileInput type="file" (change)="onFileSelected($event)" accept="image/*" class="d-none">

          <!-- Image preview -->
          @if (productData.imageUrl) {
          <img [src]="productData.imageUrl" class="img-fluid" alt="product-image" />
          }

          <!-- Upload button -->
          @if (!productData.imageUrl) {
          <div>
            <a class="btn">
              <i class="fa-solid fa-plus"></i>
            </a>
            <p class="text-muted mt-2">Click to upload<br>Or Drag & drop image here</p>
          </div>
          }
          <!-- Progress Bar -->
          @if (uploading) {
          <div class="mt-2">
            <div class="progress" role="progressbar">
              <div class="progress-bar" [style.width.%]="uploadPercent">
                {{ uploadPercent }}%
              </div>
            </div>
          </div>
          }
          <!-- Replace/Change button when image exists -->
          @if (productData.imageUrl) {
          <div>
            <a class="btn btn-sm btn-outline-primary mt-2">
              <i class="fa-solid fa-sync me-1"></i>Change Image
            </a>
          </div>
          }
        </div>
        @if (imageId) {
        <div class="mt-3">
          <img [src]="productData.imageUrl" class="img-thumbnail" width="50" />
        </div>
        }

        <!-- MAP SECTION -->
        <div class="mt-4">
          <div class="input-group mb-2">
            <input type="text" class="form-control" placeholder="Search city or place..." [(ngModel)]="searchQuery"
              name="searchLocation" (keydown.enter)="$event.preventDefault(); searchLocation()">
            <button class="btn btn-outline-secondary" type="button" (click)="searchLocation()">Search</button>
            <button class="btn btn-outline-secondary" type="button" (click)="locateMe()" title="My Location">
              <i class="fa-solid fa-crosshairs"></i>
            </button>
          </div>
          <div id="map" class="map-container"></div>
          <div *ngIf="productData.location" class="mt-2 text-muted small">
            <i class="fa-solid fa-location-dot me-1"></i>
            {{ productData.location[0] | number:'1.4-4' }}, {{ productData.location[1] | number:'1.4-4'
            }}
            <a *ngIf="productData.location"
              [href]="'https://www.google.com/maps/search/?api=1&query=' + productData.location[0] + ',' + productData.location[1]"
              target="_blank" class="ms-2">
              View on Google Maps
            </a>
          </div>
          <div *ngIf="!productData.location" class="mt-1 text-muted small fst-italic">
            Click on map to drop a pin to point exact location ..
          </div>
        </div>
      </div>
      <div class="col-md-7">
        <!-- Heading -->
        <div class="mb-3">
          <label class="form-label">Heading</label>
          <input class="form-control" [(ngModel)]="productData.title" name="heading" />
        </div>
        <div class="mb-3">
          <label class="form-label">Name</label>
          <input class="form-control" [(ngModel)]="productData.name" name="sku" required />
        </div>
        <div class="row">
          <div class="col-md-6 mb-3">
            <label class="form-label">Price {{productData.currency}}</label>
            <input type="number" class="form-control" [(ngModel)]="productData.price" name="price" required />
          </div>
          <div class="col-md-6 mb-3">
            <label class="form-label">Category</label>
            <select class="form-select" [(ngModel)]="productData.category" name="category">
              @for (c of categories; track c) {
              <option [value]="c">
                {{ c }}
              </option>
              }
            </select>
          </div>
        </div>

        <div class="mb-3">
          <label class="form-label">External Product Link</label>
          <input class="form-control" placeholder="https://amazon/paypal/product1"
            [(ngModel)]="productData.externalProductLink" name="externalProductLink" />
        </div>
        <div class="mt-4">
          <label class="form-label fw-bold">Summary</label>
          <textarea class="form-control" rows="3" [(ngModel)]="productData.summary" name="summary"></textarea>
        </div>
      </div>
    </div>

    <div class="mt-4">
      <button class="btn btn-link p-0" type="button" data-bs-toggle="collapse" data-bs-target="#extrasSection">
        ➕ Add Extras
      </button>
      <div class="collapse mt-3" id="extrasSection">
        <div class="p-3 bg-light rounded shadow-sm">
          <h5 class="fw-bold mb-3">Extra Information</h5>
          <div class="row">
            <div class="col-md-6 mb-3">
              <label class="form-label">Product Expiry</label>
              <input type="date" class="form-control" [(ngModel)]="productData.expiresAt" name="expiry" />
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label">Placement</label>
              <select class="form-select" [(ngModel)]="productData.placement" name="category">
                @for (c of placementOptions; track c) {
                <option [value]="c">
                  {{ c }}
                </option>
                }
              </select>
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label">Listing Price</label>
              <input type="number" class="form-control" [(ngModel)]="productData.listingPrice" name="lPrice" />
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label">ID <span class="fw-light">(SKU)</span></label>
              <input type="text" class="form-control" [(ngModel)]="productData.sku" name="expiry" />
            </div>
          </div>
          <div>
            <label class="form-label fw-bold">Large Description</label>
            <textarea class="form-control" rows="4" [(ngModel)]="productData.description" name="description"></textarea>
          </div>
          <div class="row mt-3">
            <div class="col-md-6 mb-3">
              <label class="form-label">Notes (private)</label>
              <textarea class="form-control" rows="1" [(ngModel)]="productData.notes" name="notes"></textarea>
            </div>
            <div class="col-md-6 mb-3">
              <label class="form-label">SEO Keywords</label>
              <input class="form-control" placeholder="keyword1, keyword2" name="keywords" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <button [disabled]="loading" class="btn btn-primary mt-4">
      {{ loading ? 'Saving…' : 'Save Product' }}
    </button>
  </form>
  @if (productData.updatedAt) {
  <div class="small text-muted mt-3 text-end fst-italic">
    Last updated by {{ productData.updatedBy || 'Unknown' }} on {{ productData.updatedAt | date:'medium' }}
  </div>
  }
</div>